package com.perpheads.bans.requests

import kotlinx.serialization.Serializable

@Serializable
data class CommentTextRequest(val text: String)